import { render, staticRenderFns } from "./paymentPermissions.vue?vue&type=template&id=556c1d08"
import script from "./paymentPermissions.vue?vue&type=script&lang=js"
export * from "./paymentPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports